import { Injectable } from '@angular/core';
import {
	ActivatedRouteSnapshot,
	Router,
	RouterStateSnapshot,
	UrlTree
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { SESSION_STORAGE_REGISTRO_PRODUCTOR_TOKEN_KEY } from 'src/app/shared/constants/session-storage-keys';

@Injectable({
	providedIn: 'root'
})
export class LoginGuard {
	constructor(
		private router: Router,
		private authService: AuthService
	) {}

	canActivate(
		route: ActivatedRouteSnapshot,
		_state: RouterStateSnapshot
	):
		| Observable<boolean | UrlTree>
		| Promise<boolean | UrlTree>
		| boolean
		| UrlTree {
		if (!this.authService.isLoggedIn()) {
			return true;
		}

		// Sesión + contexto de registro (query o sessionStorage) → montar LoginComponent.
		if (
			route.queryParamMap.get('registroToken') ||
			sessionStorage.getItem(SESSION_STORAGE_REGISTRO_PRODUCTOR_TOKEN_KEY)
		) {
			return true;
		}

		this.router.navigate(['/']);
		return false;
	}
}
